import DemandeAdmissionComplementaire from '../views/DemandeAdmissionComplementaire.vue'
import RenseignementsGeneraux from '../components/DemandeAdmissionComplementaire/RenseignementsGeneraux.vue'
import AutorisationDePratique from '../components/DemandeAdmissionComplementaire/AutorisationDePratique.vue'
import DeclarationsObligatoires from '../components/DemandeAdmissionComplementaire/DeclarationsObligatoires.vue'
import AttestationVeracite from '../components/DemandeAdmissionComplementaire/AttestationVeracite.vue'
import InformationsComplementaires from '../components/DemandeAdmissionComplementaire/InformationsComplementaires.vue'
import Formations from '../components/DemandeAdmissionComplementaire/Formations.vue'
import AutresAutorisationsDePratique from '../components/DemandeAdmissionComplementaire/AutresAutorisationsDePratique.vue'
import Langues from '../components/DemandeAdmissionComplementaire/Langues.vue'

const routeName = "DemandeAdmissionComplementaire"

export default [
	{
		path: '/demande-admission/complementaire',
		component: DemandeAdmissionComplementaire,
		meta: {
			title: 'Demande admission complémentaire | OTSTCFQ'
		},
		props: {
			isAdmissionComplementaire: true,
		},
		children: [
			{
				path: "renseignements-generaux",
				name: `${routeName}/RenseignementsGeneraux`,
				component: RenseignementsGeneraux,
			},
			{
				path: "langues",
				name: `${routeName}/Langues`,
				component: Langues
			},
			{
				path: "formations",
				name: `${routeName}/Formations`,
				component: Formations
			},
			{
				path: "declarations-obligatoires",
				name: `${routeName}/DeclarationsObligatoires`,
				component: DeclarationsObligatoires
			},
			{
				path: "attestation-veracite",
				name: `${routeName}/AttestationVeracite`,
				component: AttestationVeracite
			},
			{
				path: "autres-autorisations-de-pratique",
				name: `${routeName}/AutresAutorisationsDePratique`,
				component: AutresAutorisationsDePratique
			},
			{
				path: "autorisation-de-pratique",
				name: `${routeName}/AutorisationDePratique`,
				component: AutorisationDePratique
			},
			{
				path: "informations-complementaires",
				name: `${routeName}/InformationsComplementaires`,
				component: InformationsComplementaires
			}
		]
	}
]